import React from 'react';
import HeroSection from '../components/landingPage/HeroSection';
import CompanyOverview from '../components/landingPage/CompanyOverview';
import ExpertiseSection from '../components/landingPage/ExpertiseSection'; // New import
import QualitySection from '../components/landingPage/QualitySection'; // New import
import SustainabilitySection from '../components/landingPage/SustainabilitySection'; // New import
import CTABanner from '../components/landingPage/CTABanner'; // New import
// import WhyChooseUsSection from '../components/landingPage/WhyChooseUsSection';
// import FeaturedServicesSection from '../components/landingPage/FeaturedServicesSection';
// import CounterSection from '../components/landingPage/CounterSection'; // Corrected import
// import ProjectsGallery from '../components/landingPage/ProjectsGallery';
// import WorkedWithSection from '../components/landingPage/WorkedWithSection';
// import TestimonialSection from '../components/landingPage/TestimonialSection';
import NewsSection from '../components/landingPage/NewsSection'; // New import
// import ContactSection from '../components/landingPage/ContactSection';
// import GoogleMapSection from '../components/landingPage/GoogleMapSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen font-sans">
      <HeroSection />
      <CompanyOverview />
      <ExpertiseSection /> {/* Render ExpertiseSection */}
      <QualitySection /> {/* Render QualitySection */}
      <SustainabilitySection /> {/* Render SustainabilitySection */}
      <CTABanner /> {/* Render CTABanner */}
      {/* <AboutUsSection /> */}
      {/* <WhyChooseUsSection /> */}
      {/* <FeaturedServicesSection /> */}
      {/* <CounterSection /> Render CounterSection */}
      {/* <ProjectsGallery /> */}
      {/* <WorkedWithSection /> */}
      {/* <TestimonialSection /> */}
      <NewsSection /> {/* Render NewsSection */}
      {/* <ContactSection /> */}
      {/* <GoogleMapSection /> */}
    </div>
  );
};

export default LandingPage;